import Apis from "@/apis"
import { useElementSize } from "@/features/useElementSize"
import { PageHeader } from "@/pages/AccountPage/components/PageHeader"
import { GameCardItem } from "@/pages/HomePage/components/GameCardItem"
import { GridGameList } from "@/pages/HomePage/components/GridGameList"
import { usePaginatedList } from "@/pages/HomePage/hooks/usePaginatedRequest"
import styled from "@emotion/styled"
import { useNavigate, useParams } from "react-router-dom"
import { getGameTypeBySection } from "../hooks/useSubPage"

const Root = styled.div`
    width: 100%;
    background-color: #f5f5f5;
    flex: 1;
    display: flex;
    flex-direction: column;
`
const Content = styled.div`
    flex: 1;
`
const SectionGameList = () => {
    const navigate = useNavigate()
    const { sectionId = "" } = useParams<{ sectionId: string }>()
    const { elementRef, size } = useElementSize<HTMLDivElement>()
    const { list, loading, noMore, loadMore } = usePaginatedList<
        GameApiTypes.Fetcher.Props.GameListProps,
        GameApiTypes.Fetcher.Result.GameList
    >({
        initialQuery: {
            game_type: getGameTypeBySection(sectionId),
            is_hot: ["hot", "hot games"].includes(sectionId.toLowerCase()) ? "1" : "0",
            is_new: sectionId.toLowerCase() === "new" ? "1" : "0",
        },
        fetcher: async (props) => {
            const response = await Apis.v1.refGetGameList(props)
            return response.data.data
        },
        reloadDeps: [sectionId],
    })

    return (
        <Root>
            <PageHeader
                sticky={true}
                title={sectionId}
                iconType="black-arrow"
                textColor="#131416"
                backgroundColor="#fff"
                onBack={() => {
                    navigate(-1)
                }}
            />
            <Content ref={elementRef}>
                <GridGameList<GameApiTypes.Fetcher.Result.GameList>
                    list={list}
                    height={size?.height ?? 0}
                    itemContent={(index, game) => {
                        return (
                            <GameCardItem
                                {...game}
                                key={`games_game_item__${index}`}
                            />
                        )
                    }}
                    onLoadMore={() => {
                        if (!noMore && !loading) {
                            loadMore()
                        }
                    }}
                    isLoading={loading}
                />
            </Content>
        </Root>
    )
}

export { SectionGameList }
